"use client";

import { useState, useEffect } from "react";
import "./PwaSplash.css";

/**
 * PWA Splash Screen — only visible when the app is running in standalone/PWA mode.
 * In normal browser mode this component renders nothing.
 */
export default function PwaSplash() {
    const [isPwa, setIsPwa] = useState(false);
    const [visible, setVisible] = useState(true);
    const [fadeOut, setFadeOut] = useState(false);

    useEffect(() => {
        // Detect standalone / PWA mode
        var isStandalone = false;

        // iOS Safari
        if (typeof navigator !== "undefined" && navigator.standalone === true) {
            isStandalone = true;
        }

        // Standard display-mode media query
        if (
            typeof window !== "undefined" &&
            window.matchMedia &&
            window.matchMedia("(display-mode: standalone)").matches
        ) {
            isStandalone = true;
        }

        // TWA / fullscreen
        if (
            typeof window !== "undefined" &&
            window.matchMedia &&
            window.matchMedia("(display-mode: fullscreen)").matches
        ) {
            isStandalone = true;
        }

        if (!isStandalone) {
            setVisible(false);
            return;
        }

        setIsPwa(true);

        // Begin fade-out after 2.2 seconds
        var fadeTimer = setTimeout(function () {
            setFadeOut(true);
        }, 2200);

        // Fully remove after fade completes (0.5s transition)
        var removeTimer = setTimeout(function () {
            setVisible(false);
        }, 2700);

        return function () {
            clearTimeout(fadeTimer);
            clearTimeout(removeTimer);
        };
    }, []);

    if (!visible || !isPwa) return null;

    return (
        <div
            className={
                "pwa-splash-overlay" + (fadeOut ? " pwa-splash-fade-out" : "")
            }
            aria-hidden="true"
        >
            <div className="pwa-splash-logo-wrap">
                {/* Brand Icon */}
                <img
                    className="pwa-splash-icon"
                    src="/manabakh-brand-icon.svg"
                    alt=""
                    width={100}
                    height={100}
                    draggable={false}
                />
                {/* Brand Name */}
                <img
                    className="pwa-splash-name"
                    src="/manabakh-brand-name.svg"
                    alt="منه باخ"
                    width={140}
                    height={40}
                    draggable={false}
                />
            </div>
            {/* Spinner */}
            <div className="pwa-splash-loader" />
            {/* Tagline */}
            <p className="pwa-splash-tagline">رسانه‌ای برای تکریم زبان مادری</p>
        </div>
    );
}
